import React, { useState } from 'react';

import { Modal } from '@depop/web-ui-kit/Modal';
import { useTranslations } from 'next-intl';

import { OfferModalHeader } from '../OfferModalHeader/OfferModalHeader';

import { CounterOfferModalForm } from './CounterOfferModalForm';
import { CounterOfferModalSuccess } from './CounterOfferModalSuccess';
import styles from './styles.module.css';

import { useOffersTracking } from '@/modules/offers/buyers/hooks/useOffersTracking';
import {
  type CounterOfferProductPrice,
  type OfferRole,
} from '@/modules/offers/buyers/types';

export type Props = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  currencySymbol: string;
  productPrice: CounterOfferProductPrice;
  userRole: OfferRole;
  productId: number;
  offerId: string;
  offererUsername: string;
  imageHref?: string;
  variantId?: number;
  onOfferSent: () => void;
};

export function CounterOfferModal({
  isOpen,
  setOpen,
  currencySymbol,
  productPrice,
  userRole,
  imageHref,
  productId,
  offerId,
  variantId,
  offererUsername,
  onOfferSent,
}: Props) {
  const [hasCounterOfferSentSuccessfully, setHasCounterOfferSentSuccessfully] =
    useState(false);
  const t = useTranslations('offers');
  const { sendOffersSentViewEvent } = useOffersTracking();

  function onSuccessfulCounterOffer() {
    onOfferSent();
    setHasCounterOfferSentSuccessfully(true);
    sendOffersSentViewEvent(productId);
  }

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      hideCloseButton
      labelledBy="make-offer-modal-header"
      customOverrides={{
        floatingHeader: true,
      }}
      content={() => (
        <div className={styles.counterOfferModalContainer}>
          <OfferModalHeader
            title={
              hasCounterOfferSentSuccessfully
                ? t('CounterOfferModal.OfferSent')
                : t('CounterOfferModal.Title')
            }
            onClose={() => setOpen(false)}
            id="make-offer-modal-header"
            displayBanner={!hasCounterOfferSentSuccessfully}
          />
          {hasCounterOfferSentSuccessfully ? (
            <CounterOfferModalSuccess
              username={offererUsername}
              onExitClick={() => setOpen(false)}
            />
          ) : (
            <CounterOfferModalForm
              currencySymbol={currencySymbol}
              productPrice={productPrice}
              imageHref={imageHref}
              userRole={userRole}
              productId={productId}
              offerId={offerId}
              variantId={variantId}
              onSuccessfulCounterOffer={onSuccessfulCounterOffer}
              isOpen={isOpen}
            />
          )}
        </div>
      )}
    />
  );
}
